/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 21c0-1.857.564-3.644 1.93-4.963C5.296 14.72 7.327 14 10 14v2c-2.326 0-3.795.622-4.68 1.477C4.435 18.329 4 19.54 4 21v1H2zM5 7a5 5 0 0 1 10 0h-2a3 3 0 1 0-3 3v2a5 5 0 0 1-5-5z" />
        <path d="M22 9v13H12V9zm-8 11h6v-9h-6z" />
        <path d="M19 13v2h-4v-2zm0 3v2h-4v-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgContactList as ContactList };
